import { useContext, useEffect, useRef } from "react";
import { AuthContext } from "../AuthContext";
import AuthContextValue, { AuthStatus } from "../models/AuthContextValue";
import { Navigate, useLocation } from "react-router-dom";
import logo from "../assets/pbeej-logo.svg";
import { Button } from "@mui/material";

export default function Login() {
  const location = useLocation();
  const { status, isAuthorized, renderSignInButton, requestDriveAccess } =
    useContext<AuthContextValue>(AuthContext);
  const buttonHostRef = useRef<HTMLDivElement>(null);
  const isSigningIn = status === AuthStatus.SIGNING_IN;
  const isRequestingDriveAccess = status === AuthStatus.REQUESTING_DRIVE_ACCESS;
  const showSignIn = status === AuthStatus.SIGNED_OUT || isSigningIn;
  const showDriveAccess =
    status === AuthStatus.DRIVE_ACCESS_REQUIRED || isRequestingDriveAccess;

  useEffect(() => {
    if (status === AuthStatus.SIGNED_OUT && buttonHostRef.current) {
      renderSignInButton(buttonHostRef.current);
    }
  }, [renderSignInButton, status]);

  if (isAuthorized) {
    if (location?.state?.prevUrl) return <Navigate to={location.state.prevUrl} replace={true} />;

    return <Navigate to={"/"} replace={true} />;
  }

  return (
    <div className={"w-full h-full flex flex-col justify-center"}>
      <div className='flex items-center justify-center m-5'>
        <img src={logo} alt={"pbeej logo svg"} className='w-[400px] lg:w-[500px]' />
      </div>
      {showSignIn && (
        <div className='flex items-center justify-center mt-10'>
          {isSigningIn ? (
            <Button variant='contained' size='large' disabled>
              Signing In…
            </Button>
          ) : (
            <div ref={buttonHostRef} />
          )}
        </div>
      )}
      {showDriveAccess && (
        <div className='flex items-center justify-center mt-6'>
          <Button
            onClick={requestDriveAccess}
            variant='contained'
            size='large'
            disabled={isRequestingDriveAccess}
          >
            {isRequestingDriveAccess ? "Requesting Drive access…" : "Allow Google Drive access"}
          </Button>
        </div>
      )}
    </div>
  );
}
